/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './category.component.scss.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/router';
import * as import3 from '@angular/common';
import * as import4 from '../../../app/shared/pipes/unescape-cache-pipe';
import * as import5 from '../../../app/shared/services/stringutils';
import * as import6 from '../shared/decorator/header/header.component.ngfactory';
import * as import7 from '../../../app/shared/decorator/header/header.component';
import * as import8 from '../shared/decorator/subheader/subheader.component.ngfactory';
import * as import9 from '../../../app/shared/decorator/subheader/subheader.component';
import * as import10 from '../../../app/category/category.component';
import * as import11 from 'angular2-infinite-scroll/src/infinite-scroll';
import * as import12 from 'angular2-infinite-scroll/src/position-resolver';
import * as import13 from 'angular2-infinite-scroll/src/scroll-register';
import * as import14 from 'angular2-infinite-scroll/src/scroll-resolver';
import * as import15 from './section/section-category.component.ngfactory';
import * as import16 from '../../../app/category/section/section-category.component';
import * as import17 from '@angular/platform-browser';
import * as import18 from '../shared/subscribe/subscribe.component.ngfactory';
import * as import19 from '../../../app/shared/subscribe/subscribe.component';
import * as import20 from '../shared/menu/menu.component.ngfactory';
import * as import21 from '../../../app/shared/menu/menu.component';
import * as import22 from '../../../modules/transfer-state/transfer-state';
import * as import23 from '../../../../common/utils/costguideutils';
import * as import24 from '../../../../common/utils/articleutils';
const styles_CategoryComponent:any[] = [import0.styles];
export const RenderType_CategoryComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 2,
  styles: styles_CategoryComponent,
  data: {}
}
);
function View_CategoryComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),26,'a',([] as any[]),[
      [
        8,
        'className',
        0
      ]
      ,
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,1).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),22,'div',[[
        'class',
        'd-flex flex-column flex-md-row section-bottom-separator first-level section-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n                  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'image left-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[[
        'class',
        'img-fluid'
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                  '])),
    (l()(),import1.ɵted((null as any),['\n\n                  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),14,'div',[[
        'class',
        'd-flex flex-column right-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n                      ',
      '\n                    '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'tag'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n                      ',
      '\n                    '
    ]
    )),
    import1.ɵppd(1),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'excerpt align-items-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import1.ɵppd(1),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵted((null as any),['\n                  '])),
    (l()(),import1.ɵted((null as any),['\n\n                '])),
    (l()(),import1.ɵted((null as any),['\n              ']))
  ]
  ,(ck,v) => {
    const currVal_3:any = import1.ɵinlineInterpolate(1,'',(<any>v.parent).context.$implicit.articles[0].url,'');
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import1.ɵinlineInterpolate(1,'undecorated ',(((<any>v.parent).context.$implicit.articles[0] == null)? (null as any): (<any>v.parent).context.$implicit.articles[0].categoryId),'-section');
    const currVal_1:any = import1.ɵnov(v,1).target;
    const currVal_2:any = import1.ɵnov(v,1).href;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = import1.ɵinlineInterpolate(1,'',(<any>v.parent).context.$implicit.articles[0].unbrandedImage,'');
    ck(v,7,0,currVal_4);
    const currVal_5:any = (((<any>v.parent).context.$implicit.articles[0] == null)? (null as any): (<any>v.parent).context.$implicit.articles[0].title);
    ck(v,13,0,currVal_5);
    const currVal_6:any = import1.ɵunv(v,16,0,ck(v,17,0,import1.ɵnov((<any>(<any>v.parent).parent),0),(((<any>v.parent).context.$implicit.articles[0] == null)? (null as any): (<any>v.parent).context.$implicit.articles[0].tag)));
    ck(v,16,0,currVal_6);
    const currVal_7:any = import1.ɵunv(v,21,0,ck(v,22,0,import1.ɵnov((<any>(<any>v.parent).parent),1),(<any>v.parent).context.$implicit.articles[0].excerpt));
    ck(v,21,0,currVal_7);
  });
}
function View_CategoryComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),26,'a',([] as any[]),[
      [
        8,
        'className',
        0
      ]
      ,
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,1).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),22,'div',[[
        'class',
        'd-flex flex-column flex-md-row section-bottom-separator first-level section-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n                  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'image left-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[[
        'class',
        'img-fluid'
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                  '])),
    (l()(),import1.ɵted((null as any),['\n\n                  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),14,'div',[[
        'class',
        'd-flex flex-column right-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n                      ',
      '\n                    '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'tag'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n                      ',
      '\n                    '
    ]
    )),
    import1.ɵppd(1),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'excerpt align-items-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import1.ɵppd(1),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵted((null as any),['\n                  '])),
    (l()(),import1.ɵted((null as any),['\n\n                '])),
    (l()(),import1.ɵted((null as any),['\n              ']))
  ]
  ,(ck,v) => {
    const currVal_3:any = import1.ɵinlineInterpolate(1,'',(<any>v.parent).context.$implicit.articles[1].url,'');
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import1.ɵinlineInterpolate(1,'undecorated ',(((<any>v.parent).context.$implicit.articles[1] == null)? (null as any): (<any>v.parent).context.$implicit.articles[1].categoryId),'-section');
    const currVal_1:any = import1.ɵnov(v,1).target;
    const currVal_2:any = import1.ɵnov(v,1).href;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = import1.ɵinlineInterpolate(1,'',(<any>v.parent).context.$implicit.articles[1].unbrandedImage,'');
    ck(v,7,0,currVal_4);
    const currVal_5:any = (<any>v.parent).context.$implicit.articles[1].title;
    ck(v,13,0,currVal_5);
    const currVal_6:any = import1.ɵunv(v,16,0,ck(v,17,0,import1.ɵnov((<any>(<any>v.parent).parent),0),(<any>v.parent).context.$implicit.articles[1].tag));
    ck(v,16,0,currVal_6);
    const currVal_7:any = import1.ɵunv(v,21,0,ck(v,22,0,import1.ɵnov((<any>(<any>v.parent).parent),1),(<any>v.parent).context.$implicit.articles[1].excerpt));
    ck(v,21,0,currVal_7);
  });
}
function View_CategoryComponent_4(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),26,'a',([] as any[]),[
      [
        8,
        'className',
        0
      ]
      ,
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,1).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),22,'div',[[
        'class',
        'd-flex flex-column flex-md-row section-bottom-separator first-level section-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n                  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'image left-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[[
        'class',
        'img-fluid'
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                  '])),
    (l()(),import1.ɵted((null as any),['\n\n                  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),14,'div',[[
        'class',
        'd-flex flex-column right-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n                      ',
      '\n                    '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'tag'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n                      ',
      '\n                    '
    ]
    )),
    import1.ɵppd(1),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'excerpt align-items-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import1.ɵppd(1),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵted((null as any),['\n                  '])),
    (l()(),import1.ɵted((null as any),['\n\n                '])),
    (l()(),import1.ɵted((null as any),['\n              ']))
  ]
  ,(ck,v) => {
    const currVal_3:any = import1.ɵinlineInterpolate(1,'',(<any>v.parent).context.$implicit.articles[2].url,'');
    ck(v,1,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import1.ɵinlineInterpolate(1,'undecorated ',(((<any>v.parent).context.$implicit.articles[2] == null)? (null as any): (<any>v.parent).context.$implicit.articles[2].categoryId),'-section');
    const currVal_1:any = import1.ɵnov(v,1).target;
    const currVal_2:any = import1.ɵnov(v,1).href;
    ck(v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_4:any = import1.ɵinlineInterpolate(1,'',(<any>v.parent).context.$implicit.articles[2].unbrandedImage,'');
    ck(v,7,0,currVal_4);
    const currVal_5:any = (<any>v.parent).context.$implicit.articles[2].title;
    ck(v,13,0,currVal_5);
    const currVal_6:any = import1.ɵunv(v,16,0,ck(v,17,0,import1.ɵnov((<any>(<any>v.parent).parent),0),(<any>v.parent).context.$implicit.articles[2].tag));
    ck(v,16,0,currVal_6);
    const currVal_7:any = import1.ɵunv(v,21,0,ck(v,22,0,import1.ɵnov((<any>(<any>v.parent).parent),1),(<any>v.parent).context.$implicit.articles[2].excerpt));
    ck(v,21,0,currVal_7);
  });
}
function View_CategoryComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'd-flex flex-column'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n              '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CategoryComponent_2)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n              '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CategoryComponent_3)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n              '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CategoryComponent_4)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n            ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit.articles[0];
    ck(v,3,0,currVal_0);
    const currVal_1:any = v.context.$implicit.articles[1];
    ck(v,6,0,currVal_1);
    const currVal_2:any = v.context.$implicit.articles[2];
    ck(v,9,0,currVal_2);
  },(null as any));
}
export function View_CategoryComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵpid(0,import3.UpperCasePipe,([] as any[])),
    import1.ɵpid(0,import4.UnescapeCachePipe,[import5.StringUtils]),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'header',([] as any[]),(null as any),(null as any),(null as any),import6.View_HeaderComponent_0,import6.RenderType_HeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import7.HeaderComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),35,'div',[
      [
        'class',
        'menu-perspective effect-moveright'
      ]
      ,
      [
        'id',
        'menu-perspective'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),29,'div',[[
        'class',
        'menu-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),26,'div',[[
        'class',
        'menu-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'subheader',([] as any[]),(null as any),(null as any),(null as any),import8.View_SubHeaderComponent_0,import8.RenderType_SubHeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import9.SubHeaderComponent,([] as any[]),{
      title: [
        0,
        'title'
      ]
      ,
      class: [
        1,
        'class'
      ]

    }
    ,(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),20,'div',[
      [
        'class',
        'container'
      ]
      ,
      [
        'id',
        'category'
      ]
      ,
      [
        'infinite-scroll',
        ''
      ]

    ]
      ,(null as any),[[
        (null as any),
        'scrolled'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import10.CategoryComponent = v.component;
      if (('scrolled' === en)) {
        const pd_0:any = ((<any>co.renderMoreContent()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(212992,(null as any),0,import11.InfiniteScroll,[
      import1.ElementRef,
      import1.NgZone,
      import12.PositionResolverFactory,
      import13.ScrollRegister,
      import14.ScrollResolver
    ]
    ,{
      _distanceDown: [
        0,
        '_distanceDown'
      ]
      ,
      _throttle: [
        1,
        '_throttle'
      ]

    }
    ,{scrolled: 'scrolled'}),
    (l()(),import1.ɵted((null as any),['\n\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),16,'div',[[
        'style',
        'padding-bottom: 50px;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),[[
        8,
        'className',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'sectionCategory',([] as any[]),(null as any),(null as any),(null as any),import15.View_SectionCategoryComponent_0,import15.RenderType_SectionCategoryComponent)),
    import1.ɵdid(49152,(null as any),0,import16.SectionCategoryComponent,[import17.DOCUMENT],{
      articles: [
        0,
        'articles'
      ]
      ,
      insuranceCostGuide: [
        1,
        'insuranceCostGuide'
      ]
      ,
      homeImprovementCostGuide: [
        2,
        'homeImprovementCostGuide'
      ]

    }
    ,(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'd-flex flex-column subscribe-section'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'subscribe',([] as any[]),(null as any),(null as any),(null as any),import18.View_SubscribeComponent_0,import18.RenderType_SubscribeComponent)),
    import1.ɵdid(49152,(null as any),0,import19.SubscribeComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CategoryComponent_1)),
    import1.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n        '])),
    (l()(),import1.ɵted((null as any),['\n\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'menu',([] as any[]),(null as any),(null as any),(null as any),import20.View_MenuComponent_0,import20.RenderType_MenuComponent)),
    import1.ɵdid(4243456,(null as any),0,import21.MenuComponent,[
      'isBrowser',
      import22.TransferState,
      import23.CostGuideUtils
    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import10.CategoryComponent = v.component;
    const currVal_0:any = co.category;
    const currVal_1:any = co.categoryId;
    ck(v,12,0,currVal_0,currVal_1);
    const currVal_2:any = 2;
    const currVal_3:any = 300;
    ck(v,15,0,currVal_2,currVal_3);
    const currVal_5:any = co.articlesTopSection;
    const currVal_6:any = co.insuranceCostGuideTopSection;
    const currVal_7:any = co.homeImprovementCostGuideTopSection;
    ck(v,22,0,currVal_5,currVal_6,currVal_7);
    const currVal_8:any = co.previousBlocks;
    ck(v,32,0,currVal_8);
  },(ck,v) => {
    var co:import10.CategoryComponent = v.component;
    const currVal_4:any = (('d-flex flex-column section ' + co.categoryId) + '-section');
    ck(v,19,0,currVal_4);
  });
}
function View_CategoryComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'categoryComponent',([] as any[]),(null as any),(null as any),(null as any),View_CategoryComponent_0,RenderType_CategoryComponent)),
    import1.ɵdid(49152,(null as any),0,import10.CategoryComponent,[
      import2.ActivatedRoute,
      import24.ArticleUtils,
      import22.TransferState,
      import23.CostGuideUtils
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const CategoryComponentNgFactory:import1.ComponentFactory<import10.CategoryComponent> = import1.ɵccf('categoryComponent',import10.CategoryComponent,View_CategoryComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9idWlsZC9ob3dtdWNoL3NyYy9hcHAvY2F0ZWdvcnkvY2F0ZWdvcnkuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9idWlsZC9ob3dtdWNoL3NyYy9hcHAvY2F0ZWdvcnkvY2F0ZWdvcnkuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL2J1aWxkL2hvd211Y2gvc3JjL2FwcC9jYXRlZ29yeS9jYXRlZ29yeS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci9idWlsZC9ob3dtdWNoL3NyYy9hcHAvY2F0ZWdvcnkvY2F0ZWdvcnkuY29tcG9uZW50LnRzLkNhdGVnb3J5Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGhlYWRlcj48L2hlYWRlcj5cblxuPGRpdiBpZD1cIm1lbnUtcGVyc3BlY3RpdmVcIiBjbGFzcz1cIm1lbnUtcGVyc3BlY3RpdmUgZWZmZWN0LW1vdmVyaWdodFwiPlxuICA8ZGl2IGNsYXNzPVwibWVudS1jb250YWluZXJcIj5cbiAgICA8ZGl2IGNsYXNzPVwibWVudS13cmFwcGVyXCI+XG4gICAgICA8c3ViaGVhZGVyIFt0aXRsZV09XCJjYXRlZ29yeVwiIFtjbGFzc109XCJjYXRlZ29yeUlkXCI+PC9zdWJoZWFkZXI+XG5cbiAgICAgIDxkaXYgaW5maW5pdGUtc2Nyb2xsXG4gICAgICAgICAgIFtpbmZpbml0ZVNjcm9sbERpc3RhbmNlXT1cIjJcIlxuICAgICAgICAgICBbaW5maW5pdGVTY3JvbGxUaHJvdHRsZV09XCIzMDBcIlxuICAgICAgICAgICAoc2Nyb2xsZWQpPVwicmVuZGVyTW9yZUNvbnRlbnQoKVwiXG4gICAgICAgICAgIGlkPVwiY2F0ZWdvcnlcIiBjbGFzcz1cImNvbnRhaW5lclwiPlxuXG4gICAgICAgIDxkaXYgc3R5bGU9XCJwYWRkaW5nLWJvdHRvbTogNTBweDtcIj5cblxuICAgICAgICAgICAgPGRpdiBbY2xhc3NdPVwiJ2QtZmxleCBmbGV4LWNvbHVtbiBzZWN0aW9uICcgKyBjYXRlZ29yeUlkICsgJy1zZWN0aW9uJ1wiPlxuICAgICAgICAgICAgICA8c2VjdGlvbkNhdGVnb3J5IFthcnRpY2xlc109XCJhcnRpY2xlc1RvcFNlY3Rpb25cIiBbaW5zdXJhbmNlQ29zdEd1aWRlXT1cImluc3VyYW5jZUNvc3RHdWlkZVRvcFNlY3Rpb25cIiBbaG9tZUltcHJvdmVtZW50Q29zdEd1aWRlXT1cImhvbWVJbXByb3ZlbWVudENvc3RHdWlkZVRvcFNlY3Rpb25cIj48L3NlY3Rpb25DYXRlZ29yeT5cbiAgICAgICAgICAgIDwvZGl2PlxuXG4gICAgICAgICAgICA8ZGl2IGNsYXNzPVwiZC1mbGV4IGZsZXgtY29sdW1uIHN1YnNjcmliZS1zZWN0aW9uXCI+XG4gICAgICAgICAgICAgIDxzdWJzY3JpYmU+PC9zdWJzY3JpYmU+XG4gICAgICAgICAgICA8L2Rpdj5cblxuICAgICAgICAgICAgPGRpdiAqbmdGb3I9XCJsZXQgcHJldmlvdXNCTG9jayBvZiBwcmV2aW91c0Jsb2Nrc1wiIGNsYXNzPVwiZC1mbGV4IGZsZXgtY29sdW1uXCI+XG5cbiAgICAgICAgICAgICAgPGEgY2xhc3M9XCJ1bmRlY29yYXRlZCB7eyhwcmV2aW91c0JMb2NrLmFydGljbGVzWzBdKT8uY2F0ZWdvcnlJZH19LXNlY3Rpb25cIiAqbmdJZj1cInByZXZpb3VzQkxvY2suYXJ0aWNsZXNbMF1cIiByb3V0ZXJMaW5rPVwie3twcmV2aW91c0JMb2NrLmFydGljbGVzWzBdLnVybH19XCI+XG4gICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cImQtZmxleCBmbGV4LWNvbHVtbiBmbGV4LW1kLXJvdyBzZWN0aW9uLWJvdHRvbS1zZXBhcmF0b3IgZmlyc3QtbGV2ZWwgc2VjdGlvbi1wYXJ0XCI+XG5cbiAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJpbWFnZSBsZWZ0LXBhcnRcIj5cbiAgICAgICAgICAgICAgICAgICAgPGltZyBjbGFzcz1cImltZy1mbHVpZFwiIHNyYz1cInt7cHJldmlvdXNCTG9jay5hcnRpY2xlc1swXS51bmJyYW5kZWRJbWFnZX19XCI+XG4gICAgICAgICAgICAgICAgICA8L2Rpdj5cblxuICAgICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cImQtZmxleCBmbGV4LWNvbHVtbiByaWdodC1wYXJ0XCI+XG4gICAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJ0aXRsZVwiPlxuICAgICAgICAgICAgICAgICAgICAgIHt7KHByZXZpb3VzQkxvY2suYXJ0aWNsZXNbMF0pPy50aXRsZX19XG4gICAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwidGFnXCI+XG4gICAgICAgICAgICAgICAgICAgICAge3socHJldmlvdXNCTG9jay5hcnRpY2xlc1swXSk/LnRhZyB8IHVwcGVyY2FzZX19XG4gICAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwiZXhjZXJwdCBhbGlnbi1pdGVtcy1jZW50ZXJcIj5cbiAgICAgICAgICAgICAgICAgICAgICA8cCBbaW5uZXJIVE1MXT1cInByZXZpb3VzQkxvY2suYXJ0aWNsZXNbMF0uZXhjZXJwdCB8IHVuZXNjYXBlQ2FjaGVcIj48L3A+XG4gICAgICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICAgICAgPC9kaXY+XG5cbiAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgPC9hPlxuXG4gICAgICAgICAgICAgIDxhIGNsYXNzPVwidW5kZWNvcmF0ZWQge3socHJldmlvdXNCTG9jay5hcnRpY2xlc1sxXSk/LmNhdGVnb3J5SWR9fS1zZWN0aW9uXCIgKm5nSWY9XCJwcmV2aW91c0JMb2NrLmFydGljbGVzWzFdXCIgcm91dGVyTGluaz1cInt7cHJldmlvdXNCTG9jay5hcnRpY2xlc1sxXS51cmx9fVwiPlxuICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJkLWZsZXggZmxleC1jb2x1bW4gZmxleC1tZC1yb3cgc2VjdGlvbi1ib3R0b20tc2VwYXJhdG9yIGZpcnN0LWxldmVsIHNlY3Rpb24tcGFydFwiPlxuXG4gICAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwiaW1hZ2UgbGVmdC1wYXJ0XCI+XG4gICAgICAgICAgICAgICAgICAgIDxpbWcgY2xhc3M9XCJpbWctZmx1aWRcIiBzcmM9XCJ7e3ByZXZpb3VzQkxvY2suYXJ0aWNsZXNbMV0udW5icmFuZGVkSW1hZ2V9fVwiPlxuICAgICAgICAgICAgICAgICAgPC9kaXY+XG5cbiAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJkLWZsZXggZmxleC1jb2x1bW4gcmlnaHQtcGFydFwiPlxuICAgICAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwidGl0bGVcIj5cbiAgICAgICAgICAgICAgICAgICAgICB7e3ByZXZpb3VzQkxvY2suYXJ0aWNsZXNbMV0udGl0bGV9fVxuICAgICAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cInRhZ1wiPlxuICAgICAgICAgICAgICAgICAgICAgIHt7cHJldmlvdXNCTG9jay5hcnRpY2xlc1sxXS50YWcgfCB1cHBlcmNhc2V9fVxuICAgICAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cImV4Y2VycHQgYWxpZ24taXRlbXMtY2VudGVyXCI+XG4gICAgICAgICAgICAgICAgICAgICAgPHAgW2lubmVySFRNTF09XCJwcmV2aW91c0JMb2NrLmFydGljbGVzWzFdLmV4Y2VycHQgfCB1bmVzY2FwZUNhY2hlXCI+PC9wPlxuICAgICAgICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgICAgICAgIDwvZGl2PlxuXG4gICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgIDwvYT5cblxuICAgICAgICAgICAgICA8YSBjbGFzcz1cInVuZGVjb3JhdGVkIHt7KHByZXZpb3VzQkxvY2suYXJ0aWNsZXNbMl0pPy5jYXRlZ29yeUlkfX0tc2VjdGlvblwiICpuZ0lmPVwicHJldmlvdXNCTG9jay5hcnRpY2xlc1syXVwiIHJvdXRlckxpbms9XCJ7e3ByZXZpb3VzQkxvY2suYXJ0aWNsZXNbMl0udXJsfX1cIj5cbiAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwiZC1mbGV4IGZsZXgtY29sdW1uIGZsZXgtbWQtcm93IHNlY3Rpb24tYm90dG9tLXNlcGFyYXRvciBmaXJzdC1sZXZlbCBzZWN0aW9uLXBhcnRcIj5cblxuICAgICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cImltYWdlIGxlZnQtcGFydFwiPlxuICAgICAgICAgICAgICAgICAgICA8aW1nIGNsYXNzPVwiaW1nLWZsdWlkXCIgc3JjPVwie3twcmV2aW91c0JMb2NrLmFydGljbGVzWzJdLnVuYnJhbmRlZEltYWdlfX1cIj5cbiAgICAgICAgICAgICAgICAgIDwvZGl2PlxuXG4gICAgICAgICAgICAgICAgICA8ZGl2IGNsYXNzPVwiZC1mbGV4IGZsZXgtY29sdW1uIHJpZ2h0LXBhcnRcIj5cbiAgICAgICAgICAgICAgICAgICAgPGRpdiBjbGFzcz1cInRpdGxlXCI+XG4gICAgICAgICAgICAgICAgICAgICAge3twcmV2aW91c0JMb2NrLmFydGljbGVzWzJdLnRpdGxlfX1cbiAgICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJ0YWdcIj5cbiAgICAgICAgICAgICAgICAgICAgICB7e3ByZXZpb3VzQkxvY2suYXJ0aWNsZXNbMl0udGFnIHwgdXBwZXJjYXNlfX1cbiAgICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgICAgIDxkaXYgY2xhc3M9XCJleGNlcnB0IGFsaWduLWl0ZW1zLWNlbnRlclwiPlxuICAgICAgICAgICAgICAgICAgICAgIDxwIFtpbm5lckhUTUxdPVwicHJldmlvdXNCTG9jay5hcnRpY2xlc1syXS5leGNlcnB0IHwgdW5lc2NhcGVDYWNoZVwiPjwvcD5cbiAgICAgICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgICA8L2Rpdj5cblxuICAgICAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgICAgICA8L2E+XG5cbiAgICAgICAgICAgIDwvZGl2PlxuXG4gICAgICAgIDwvZGl2PlxuXG4gICAgICA8L2Rpdj5cbiAgICA8L2Rpdj5cbiAgPC9kaXY+XG4gIDxtZW51PjwvbWVudT5cbjwvZGl2PlxuIiwiPGNhdGVnb3J5Q29tcG9uZW50PjwvY2F0ZWdvcnlDb21wb25lbnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lDeUJjO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO0lBQUE7Z0JBQUE7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBNEo7TUFDMUo7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUE4RjtNQUU1RjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTZCO01BQzNCO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTBFO0lBQ3RFO01BRU47UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEyQztNQUN6QztRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQW1CO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFFYjtNQUNOO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBaUI7TUFBQTtNQUFBO0lBQUE7SUFBQTtnQkFBQTtJQUVYO01BQ047UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF3QztNQUN0QztRQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUc7SUFBb0U7SUFDbkU7SUFDRjtJQUVGOzs7SUFuQnFHO0lBQTdHLFNBQTZHLFNBQTdHOztJQUFHO0lBQUg7SUFBQTtJQUFBLFNBQUcsVUFBSCxtQkFBQTtJQUk2QjtJQUF2QixTQUF1QixTQUF2QjtJQUltQjtJQUFBO0lBR0Y7SUFBQTtJQUlaO0lBQUgsVUFBRyxTQUFIOzs7OztJQU9SO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO0lBQUE7Z0JBQUE7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBNEo7TUFDMUo7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUE4RjtNQUU1RjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTZCO01BQzNCO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTBFO0lBQ3RFO01BRU47UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEyQztNQUN6QztRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQW1CO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFFYjtNQUNOO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBaUI7TUFBQTtNQUFBO0lBQUE7SUFBQTtnQkFBQTtJQUVYO01BQ047UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF3QztNQUN0QztRQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUc7SUFBb0U7SUFDbkU7SUFDRjtJQUVGOzs7SUFuQnFHO0lBQTdHLFNBQTZHLFNBQTdHOztJQUFHO0lBQUg7SUFBQTtJQUFBLFNBQUcsVUFBSCxtQkFBQTtJQUk2QjtJQUF2QixTQUF1QixTQUF2QjtJQUltQjtJQUFBO0lBR0Y7SUFBQTtJQUlaO0lBQUgsVUFBRyxTQUFIOzs7OztJQU9SO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO0lBQUE7Z0JBQUE7Ozs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBNEo7TUFDMUo7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUE4RjtNQUU1RjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTZCO01BQzNCO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTBFO0lBQ3RFO01BRU47UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEyQztNQUN6QztRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQW1CO01BQUE7TUFBQTtJQUFBO0lBQUE7SUFFYjtNQUNOO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBaUI7TUFBQTtNQUFBO0lBQUE7SUFBQTtnQkFBQTtJQUVYO01BQ047UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF3QztNQUN0QztRQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUc7SUFBb0U7SUFDbkU7SUFDRjtJQUVGOzs7SUFuQnFHO0lBQTdHLFNBQTZHLFNBQTdHOztJQUFHO0lBQUg7SUFBQTtJQUFBLFNBQUcsVUFBSCxtQkFBQTtJQUk2QjtJQUF2QixTQUF1QixTQUF2QjtJQUltQjtJQUFBO0lBR0Y7SUFBQTtJQUlaO0lBQUgsVUFBRyxTQUFIOzs7OztNQTdEVjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTZFO0lBRTNFO2dCQUFBOzs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFvQkk7SUFFSjtnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBb0JJO0lBRUo7Z0JBQUE7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQW9CSTs7O0lBaEV1RTtJQUEzRSxTQUEyRSxTQUEzRTtJQXNCMkU7SUFBM0UsU0FBMkUsU0FBM0U7SUFzQjJFO0lBQTNFLFNBQTJFLFNBQTNFOzs7Ozs7O0lBckVkO2dCQUFBO0lBQWlCO0lBRWpCO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtJQUFxRTtNQUNuRTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQTRCO01BQzFCO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBMEI7SUFDeEI7Z0JBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO0lBQStEO0lBRS9EO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUdLO1FBQUE7UUFBQTtNQUFBO01BSEw7SUFBQTtnQkFBQTs7Ozs7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7SUFJcUM7TUFFbkM7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFtQztNQUUvQjtRQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBdUU7SUFDckU7Z0JBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO0lBQXVMO0lBQ25MO01BRU47UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFrRDtJQUNoRDtnQkFBQTtJQUF1QjtJQUNuQjtJQUVOO2dCQUFBOzs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBb0VNO0lBRUo7SUFFRjtJQUNGO0lBQ0Y7SUFDTjtnQkFBQTtNQUFBOzs7SUFBQTtLQUFBO0lBQWE7SUFDVDs7OztJQTlGVztJQUFtQjtJQUE5QixVQUFXLFVBQW1CLFNBQTlCO0lBR0s7SUFDQTtJQUZMLFVBQ0ssVUFDQSxTQUZMO0lBU3lCO0lBQWdDO0lBQW9EO0lBQXJHLFVBQWlCLFVBQWdDLFVBQW9ELFNBQXJHO0lBT0c7SUFBTCxVQUFLLFNBQUw7OztJQVJLO0lBQUwsVUFBSyxTQUFMOzs7OztJQ2ZaO2dCQUFBOzs7OztJQUFBO0tBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/ngfactory/app/category/category.component.ngfactory.ts